import { useCallback } from "react";

import { useHistory } from "react-router-dom";
import type { Route } from "static-route-paths";

export { routes } from "../../ui/routes";

type NavigateToOptions = {
  replace?: boolean;
};

const defaultNavigateToOptions: NavigateToOptions = {
  replace: false,
};

type RouteObj = { [key: string]: Route } | { [key: string]: string | number };

const useNavigate = () => {
  const history = useHistory();

  const navigateTo = useCallback(
    (url: Route, withValues?: RouteObj, options: NavigateToOptions = defaultNavigateToOptions) => {
      const hasValues = withValues && Object.keys(withValues).length > 0;
      const destination = hasValues ? url.with(withValues) : url.path;

      if (options.replace) {
        history.replace(destination);
      } else {
        history.push(destination);
      }
    },
    [history],
  );

  const navigateToURL = useCallback(
    (url: string) => {
      history.push(url);
    },
    [history],
  );

  const willNavigateTo = useCallback(
    (url: Route, withValues?: RouteObj, options: NavigateToOptions = defaultNavigateToOptions) => {
      return () => {
        return navigateTo(url, withValues, options);
      };
    },
    [navigateTo],
  );

  return { navigateTo, navigateToURL, willNavigateTo };
};

export default useNavigate;
